@for (panel of metadataPanels(); track panel.key) {
    <app-expansion-panel [isExpanded]="true">
        <div header>
            <span class="font-medium text-xl">
                {{ panel.label | transloco }}
            </span>
        </div>

        <div
            class="flex flex-col gap-3"
            content>
            @for (entry of panel.entries; track entry.label) {
                <div class="grid grid-cols-[120px_1fr] gap-x-6">
                    <span class="text-outline capitalize">
                        {{ entry.label }}
                    </span>
                    <span class="break-words whitespace-pre-line">
                        {{ entry.value }}
                    </span>
                </div>
            } @empty {
                <span class="text-outline font-normal">
                    {{ 'noDataToShow' | transloco }}
                </span>
            }
        </div>
    </app-expansion-panel>
}
